import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames'
import {
  OverridableComponent
} from '@mui/material/OverridableComponent'
import {
  SvgIconTypeMap
} from '@mui/material/SvgIcon'
import Snackbar from '@mui/material/Snackbar'
import SnackbarContent from '@mui/material/SnackbarContent'
import IconButton from '@mui/material/IconButton'

import CloseIcon from '@mui/icons-material/Close'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import WarningIcon from '@mui/icons-material/Warning'
import ErrorIcon from '@mui/icons-material/Error'
import InfoIcon from '@mui/icons-material/Info'

import {
  SnackbarStateType,
} from '../../../types/frontend/store'

import {
  IVoidCallback,
} from '../../../types/utils'

import {
  getStatusColors,
} from '../../utils/color'

const variantIcon: {
  [name: string]: any,
} = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
}

type ClassnameKey = 'icon' | 'iconVariant' | 'message' | 'close' | 'success' | 'warning' | 'error' | 'info' | 'margin'

const useStyles = makeStyles(theme => {
  const {
    success,
    warning,
    error,
    info,
  } = getStatusColors(theme)
  return {
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(1),
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
    close: {
      padding: theme.spacing(0.5),
    },
    success: {
      backgroundColor: success,
    },
    warning: {
      backgroundColor: warning,
    },
    error: {
      backgroundColor: error,
    },
    info: {
      backgroundColor: info,
    },
    margin: {
      margin: theme.spacing(1),
    },
  }
})

const SnackbarRender: FC<React.PropsWithChildren<{
  open: boolean,
  text: string,
  type: SnackbarStateType,
  onClose: IVoidCallback,
}>> = ({
  open,
  text,
  type,
  onClose,
}) => {
  const classes = useStyles()
  const Icon = variantIcon[type]

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={ open }
        autoHideDuration={ 3000 }
        disableWindowBlurListener={ true }
        onClose={ onClose }
      >
        <SnackbarContent
          className={ classNames(classes[type as ClassnameKey], classes.margin) }
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={ classes.message }>
              { 
                Icon && (
                  <Icon 
                    className={ classNames(classes.icon, classes.iconVariant) }
                  />
                )
              }
              { text }
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={ classes.close }
              onClick={ onClose }
              size="large">
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </div>
  );
}

export default SnackbarRender